export default __webpack_public_path__ + "media/images/casatb/tenant/diamond-two-0718801270f797af7f917e1ebd435d16.png";